import {EmailApi} from '../api/email-api';

export const EmailUtils = {
  data () {
    return {
      currentEmail: null,
      showEmailModal: false
    };
  },
  methods: {
    /** @param email {EmailBasicDto} */
    getEmail (email) {
      this.showGlobalLoadingOverlay();
      EmailApi.getById(email.id)
      .then(response => this.currentEmail = response.body)
      .catch(this.handleErrorResponse)
      .finally(this.hideGlobalLoadingOverlay);
    }
  },
  watch: {
    currentEmail () {
      this.showEmailModal = !!this.currentEmail;
    },
    showEmailModal () {
      if (!this.showEmailModal) {
        this.currentEmail = null;
      }
    }
  },
};
